import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { getDataAttributes } from '../../../../../../../util/getDataAttributes/getDataAttributes.js';
import '../../../../../../../util/styles/index.js';
import { useAdsStyles } from '../../../../../../../util/styles/hooks/useAdsStyles.js';

var _excluded = ["id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var LABEL_CONTAINER_STYLES = {
  display: 'flex',
  gap: '2',
  alignItems: 'center'
};
var useLabelContainer = function useLabelContainer(_ref) {
  var id = _ref.id,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useAdsStyles = useAdsStyles(),
    mapAdsStyles = _useAdsStyles.mapAdsStyles;
  var _getDataAttributes = getDataAttributes(props),
    dataAttributes = _getDataAttributes.dataAttributes,
    rest = _getDataAttributes.rest;
  return {
    labelContainerProps: _objectSpread(_objectSpread(_objectSpread({}, mapAdsStyles(LABEL_CONTAINER_STYLES)), {}, {
      id: id
    }, dataAttributes), rest)
  };
};

export { useLabelContainer };
//# sourceMappingURL=useLabelContainer.js.map
